import type React from 'react'

import { MarkerF, type MarkerProps } from '@react-google-maps/api'

import { svgCarMarker } from '@/components/atoms/MapSvgMarker/svgCarMarker.ts'

import { markerLabel } from './markerLabel.ts'

export type CarMarkerProps = {
  label: string
  status: 'pending' | 'allocated' | 'assigned' | 'onboarded' | 'available' | 'paused' | 'returning' | 'onboardFlagged'
  manual?: boolean
  electric?: boolean
  vip?: boolean
  flagged?: boolean
  children?: React.ReactNode
} & Omit<MarkerProps, 'icon' | 'label'>

export const CarMarker: React.FC<CarMarkerProps> = ({
  label,
  status,
  manual,
  electric,
  vip,
  flagged,
  children,
  ...props
}) => (
  <MarkerF
    {...props}
    icon={{
      url: `data:image/svg+xml;utf-8,${encodeURIComponent(svgCarMarker(status, { flagged, manual, electric, vip }))}`,
      scaledSize: new google.maps.Size(36, 36),
      labelOrigin: new google.maps.Point(18, 16),
      // Adjustments because of the shadow
      anchor: new google.maps.Point(18, 28),
    }}
    label={markerLabel(label, status)}>
    {children}
  </MarkerF>
)
